// deps
import React, { useContext, useEffect, useState } from "react";
import { CheckoutContext, CheckoutRoute } from "@swiggy-private/checkout-core";
import { captureError, GenericError, RouteProps, AsyncComponent } from "@swiggy-private/core-ui";
import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Base/BaseTheme";
import { ThemeProvider } from "@swiggy-private/dls-web-theme/dist/components/ThemeProvider";
import { clearDineCashPoolingIntent } from "@dineout-cart-client/helpers/DineCashPooling";
import { DineoutSharedCartContext } from "@dineout-cart-client/contexts/DineCashPoolingContext";

interface IProps {
    orderId?: string;
}

async function asyncPromise() {
    try {
        const module = await import("@swiggy-private/dineout-payment-success-ui");
        return module.DineoutPaymentSuccess as React.ComponentType;
    } catch (err) {
        captureError(err);
        return () => <GenericError />;
    }
}

const DineoutPaymentSuccess = (_props: RouteProps<CheckoutRoute>) => {
    const { checkoutState } = useContext(CheckoutContext);
    const { setUserIntent } = useContext(DineoutSharedCartContext);
    const props = {
        orderId: (_props?.data as IProps)?.orderId || (checkoutState.payload as IProps)?.orderId,
    };

    const [colorMode, setColorMode] = useState<"dark" | "light" | undefined>(undefined);

    useEffect(() => {
        if (document.getElementsByTagName("html")[0].classList.contains("dark")) {
            setColorMode("dark");
            return;
        }
        if (document.getElementsByTagName("html")[0].classList.contains("light")) {
            setColorMode("light");
            return;
        }
    }, []);

    useEffect(() => {
        clearDineCashPoolingIntent();
        setUserIntent(false);
    }, [setUserIntent]);

    return (
        <ThemeProvider theme={BaseTheme} colorMode={colorMode}>
            <AsyncComponent resolve={asyncPromise} {...props} />
        </ThemeProvider>
    );
};

export default DineoutPaymentSuccess;
